import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@/components/ui/Button';
import { DASHBOARD_LABELS } from '@/constants/static/dashboardLabels';

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

const ErrorState = ({
  title = DASHBOARD_LABELS.errorState.defaultTitle,
  message = DASHBOARD_LABELS.errorState.defaultMessage,
  onRetry,
}: ErrorStateProps) => {
  return (
    <div className="nova-error-state text-center py-5" role="alert" aria-live="assertive">
      <div className="nova-error-icon mb-3">
        <FontAwesomeIcon icon={faCircleExclamation} size="3x" />
      </div>
      <h4 className="nova-error-title">{title}</h4>
      <p className="nova-error-message mb-4">{message}</p>
      {onRetry && (
        <Button onClick={onRetry} aria-label={DASHBOARD_LABELS.errorState.retryAriaLabel}>
          {DASHBOARD_LABELS.errorState.retry}
        </Button>
      )}
    </div>
  );
};

export default ErrorState;
